import { useQuery } from '@tanstack/react-query';
import { referenceDataService } from '../services/reference-data.service';
import { suppliersService } from '../services/suppliers.service';

export const useCountries = () =>
  useQuery({
    queryKey: ['reference-data', 'countries'],
    queryFn: () => referenceDataService.getCountries(),
  });

export const useRegions = () =>
  useQuery({
    queryKey: ['reference-data', 'regions'],
    queryFn: () => referenceDataService.getRegions(),
  });

export const useSubRegions = () =>
  useQuery({
    queryKey: ['reference-data', 'sub-regions'],
    queryFn: () => referenceDataService.getSubRegions(),
  });

export const useVarieties = () =>
  useQuery({
    queryKey: ['reference-data', 'varieties'],
    queryFn: () => referenceDataService.getVarieties(),
  });

export const useBottleTypes = () =>
  useQuery({
    queryKey: ['reference-data', 'bottle-types'],
    queryFn: () => referenceDataService.getBottleTypes(),
  });

export const useClosureTypes = () =>
  useQuery({
    queryKey: ['reference-data', 'closure-types'],
    queryFn: () => referenceDataService.getClosureTypes(),
  });

export const usePackingTypes = () =>
  useQuery({
    queryKey: ['reference-data', 'packing-types'],
    queryFn: () => referenceDataService.getPackingTypes(),
  });

export const useSupplierFilterOptions = () =>
  useQuery({
    queryKey: ['suppliers', 'filter-options'],
    queryFn: () => suppliersService.getFilterOptions(),
  });
